module.exports = __webpack_public_path__ + "static/parade-2020-house38-7480032b41de2857a412f3a7279446ed.jpg";